import { parseAsArrayOf, parseAsString, useQueryState } from 'nuqs';

export const useSearchQueryState = () => {
  const [state, setState] = useQueryState('state');
  const [address, setAddress] = useQueryState('address');
  const [country, setCountry] = useQueryState('country');
  const [city, setCity] = useQueryState('city');
  const [minPrice, setMinPrice] = useQueryState('min_price');
  const [maxPrice, setMaxPrice] = useQueryState('max_price');
  const [placeId, setPlaceId] = useQueryState('place_id');
  const [categories, setCategories] = useQueryState(
    'categories',
    parseAsArrayOf(parseAsString),
  );

  return {
    placeId,
    setPlaceId,
    state,
    setState,
    address,
    setAddress,
    country,
    setCountry,
    city,
    setCity,
    minPrice,
    setMinPrice,
    maxPrice,
    setMaxPrice,
    categories,
    setCategories,
  };
};
